var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSociualFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 5.5,
    fill: "#F7F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 5.5,
    stroke: "#F1F1F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_140_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 22C32 16.4771 27.5229 12 22 12C16.4771 12 12 16.4771 12 22C12 26.9912 15.6568 31.1283 20.4375 31.8785V24.8906H17.8984V22H20.4375V19.7969C20.4375 17.2906 21.9305 15.9062 24.2146 15.9062C25.3084 15.9062 26.4531 16.1016 26.4531 16.1016V18.5625H25.1922C23.95 18.5625 23.5625 19.3334 23.5625 20.125V22H26.3359L25.8926 24.8906H23.5625V31.8785C28.3432 31.1283 32 26.9912 32 22Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_140_347"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSociualFacebook);
export default __webpack_public_path__ + "static/media/sociual-facebook.78b35e122ec028c0f9c162f352efb088.svg";
export { ForwardRef as ReactComponent };